import { useState } from 'react'
import { ProposalFlick, ChangesFlick } from '@/components/HomeUpdateFlick'

/**
 * Home の「AIからのお知らせ」。2026-06-15 のモデル更新で、AIの内部種類
 * （観察/要確認/読みもの）での分類をやめ、ユーザーの動作で 2 ブロックに割る:
 *
 *  ❶ あなたが決めること  = 承認待ちの更新候補（before→after・横フリック・これにする/ちがう/あとで）
 *  ❷ AIが見つけた、あなたの変化 = arc/theme/self_doc の更新（横フリック・見た✓ / ここ違う→直す）
 *
 * silence-first: どちらも中身が無ければセクションごと非表示。
 * 子は display:none 下でも mount され、fetch 後に onContent でコンテンツ有無を親へ報告する
 * （見出しだけが浮く・空の枠が一瞬出るのを防ぐ）。
 */
export function AIDigestSection() {
  const [hasProposals, setHasProposals] = useState(false)
  const [hasChanges, setHasChanges] = useState(false)
  const anything = hasProposals || hasChanges

  return (
    <section
      style={{
        display: anything ? 'block' : 'none',
        marginBottom: 16,
        padding: '14px 14px 12px',
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 10,
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: 'var(--text3)',
          textTransform: 'uppercase',
          letterSpacing: '.08em',
          marginBottom: 12,
        }}
      >
        AI からのお知らせ
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <ProposalFlick onContent={setHasProposals} />
        <ChangesFlick onContent={setHasChanges} />
      </div>
    </section>
  )
}
